import { useEffect, useState, useRef } from "react";
import { HelpCircle } from "lucide-react";
import PortalTour from "@/components/PortalTour";
import { getSeenTours, markTourSeen } from "@/lib/tourState";

// Pulsante "Guida" + tour guidato riutilizzabile per le pagine admin.
// onOpen: chiamato quando il tour si apre (auto al primo accesso o dal pulsante).
// onClose: chiamato quando il tour si chiude (Fine / X / skip).
export default function PageTour({ steps, storageKey, className = "", onOpen, onClose }) {
  const [open, setOpen] = useState(false);
  const wasOpen = useRef(false);

  useEffect(() => {
    if (!storageKey) return;
    let cancelled = false;
    let timer = null;
    // Lo stato "visto" è persistito sul server (per utente) → non riparte su altri dispositivi.
    // localStorage resta come fallback rapido/offline.
    let localSeen = false;
    try { localSeen = !!localStorage.getItem(storageKey); } catch { localSeen = true; }
    getSeenTours().then((seen) => {
      if (cancelled) return;
      if (!localSeen && !seen.has(storageKey)) {
        timer = setTimeout(() => { if (!cancelled) setOpen(true); }, 700);
      }
    });
    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, [storageKey]);

  // Notifica apertura/chiusura ai consumatori (es. creazione/pulizia pratica demo).
  useEffect(() => {
    if (open && !wasOpen.current) { wasOpen.current = true; onOpen?.(); }
    else if (!open && wasOpen.current) { wasOpen.current = false; onClose?.(); }
  }, [open, onOpen, onClose]);

  const close = () => {
    setOpen(false);
    if (storageKey) {
      try { localStorage.setItem(storageKey, "1"); } catch { /* noop */ }
      markTourSeen(storageKey);
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="page-tour-button"
        className={`inline-flex items-center gap-1.5 text-sm font-medium text-[#007BFF] hover:underline ${className}`}>
        <HelpCircle className="h-4 w-4" />Guida
      </button>
      {open && <PortalTour steps={steps} onClose={close} />}
    </>
  );
}
